<template>
  <div class="layout-common">
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <div class="register-result">
      <img style="width:100px" src="@assets/img/finish.png" class="icon">
      <div class="txt1">Successed</div>
      <div class="txt2">Congratulations，{{ company }}，you have successfully registered {{ exname }}，Your registration
        receipt has been sent to the mailbox of the exhibition contact. Please check it.<br />
        If you have any questions, you can call 010-63430880 or info@www.NHNE-china.cn</div>

      <div class="f-tac  btn">
        <Button type="primary" size="large" @click="linkTo">Back</Button>
      </div>
      <img src="@assets/img/qrCode.png">
      <div class="txt3">WeChat</div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
export default {
  name: 'register-result',
  components: {
    gSwiper,
  },
  data() {
    return {
      company: '',
      exname: '',
      arr: [{ id: 1, path: require('../../../../assets/img/banner.jpg') }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    linkTo() {
      window.location.href = 'https://www.nhnexpo.com/';
    }
  },
  created() {
  },
  mounted() {
    const query = this.$route.query;
    this.company = query.company;
    this.exname = query.exname;
    console.log('query', query);
  }
}

</script>

<style lang="scss" scoped>
.layout-common {

  margin: 0 auto;
}

.register-result {
  width: 100%;
  text-align: center;

  .icon {
    display: block;
    margin: 80px auto 25px;
  }

  .txt1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .txt2 {
    font-size: 16px;
    color: #333;
    margin-bottom: 25px;
    line-height: 1.8;
    padding: 20px;
  }

  .txt3 {
    font-size: 14px;
    color: #666;
    margin-bottom: 120px;
  }
}

.btn {
  button {
    height: 48px;
    padding: 0 50px;
    background-color: #fff;
    font-size: 18px;
    border-radius: 5px;
    border: solid 1px #e5e5e5;
    margin-bottom: 80px;
    color: #333;
  }
}
</style>
